module.exports = __webpack_public_path__ + "static/img/siege_expert3.b4abf47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/siege_expert3.png
// module id = gfPb
// module chunks = 0